import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LeadAnimation","AppointmentAnimation","MarketingAnimation","DataDrivenAnimation","WorkflowAnimation"] */ "/vercel/path0/src/components/ui/lottie-animation.tsx");
